import {useLocale} from "i18n";
import Seo from "../seo/Seo";
import {ContactContent} from "../home/landing/ContactContent";
import {contactCopy} from "../home/landing/copy/contact";

/**
 * Public, pre-rendered **Contact & Support** page (`/contact`, issue ui#133).
 *
 * Thin wrapper (mirrors {@link ./PricingRoute.tsx}): mounts `<Seo>` + the page body. Both the SEO
 * strings and the body copy live in the page's own copy module — {@link ../home/landing/copy/contact.ts}
 * — so a content agent edits only that module and {@link ../home/landing/ContactContent.tsx}, never
 * this wrapper. The canonical URL is derived from `path` by `<Seo>` per active locale (transferify.eu
 * vs transferify.ro), so the `/ro` mirror needs no separate wiring.
 */
export function Component() {
	const {locale} = useLocale();
	const {seo} = contactCopy[locale];
	return (
		<>
			<Seo title={seo.title} description={seo.description} path="/contact"/>
			<ContactContent/>
		</>
	);
}
